'use strict';

import React from 'react';
import { render } from 'react-dom';
import bootMobileNav from './mobile-nav.js';
import Menus from "./Menus.js";

jQuery($ => {
	bootMobileNav($);
	
	const target_element = document.getElementById('navbar--dynamic-menus');
	if (target_element) {
		render(
			<Menus
				menus={ $('.nav-dropdown') }
				admin_content={ $('#navbar--admin-content').html() }
				article_key={ $('meta[name=internachi-article]').attr('content') }
				csrf={ $('meta[name=csrf-token]').attr('content') }
				swiftype_engine={ $('meta[name=swiftype-engine]').attr('content') }
				current_url={ window.location.href }
			/>,
			target_element,
			() => {
				$('#navbar--static-menus').attr('class', 'hidden');
			}
		);
	}
});
